import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import uiActions from 'core/ui/actions';
import buttonLinkStyles from 'styles/buttonLink';

const styles = ({ links, palette, screenSizes, typography }) => ({
  activeNavItem: {
    '& $link': {
      color: palette.text,
    },

    textDecoration: 'underline',
  },
  link: {
    ...buttonLinkStyles({ links }),
    ...typography.h1,
    color: palette.secondary,
    fontWeight: typography.fontWeights.normal,
    textDecoration: 'none',
    textTransform: 'uppercase',
  },
  navItem: {
    flex: 'auto',
    padding: 0,
  },
  root: {
    display: 'none',
    justifyContent: 'center',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'center',

    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      display: 'flex',
    },
  },
});

export const GroupsNavBare = ({ activeGroup, classes, groups, setActiveGroup }) => {
  if (!groups || Object.keys(groups).length <= 0) {
    return null;
  }
  return (
    <ul className={classnames('nav nav-tabs', classes.root)}>
      {Object.keys(groups).map((groupName) => (
        <li
          key={groupName}
          role="presentation"
          className={classnames(
            {
              [classes.activeNavItem]: groupName === activeGroup,
              active: groupName === activeGroup,
              'desktop-hidden': groups[groupName].desktop,
              'mobile-hidden': !groups[groupName].desktop,
            },
            classes.navItem,
          )}
        >
          <button
            type="button"
            data-name={groupName}
            onClick={(e) => {
              e.preventDefault();
              setActiveGroup(groupName);
            }}
            className={classnames('buttonLink', classes.link)}
          >
            {groups[groupName].labelMobile}
          </button>
        </li>
      ))}
    </ul>
  );
};

GroupsNavBare.propTypes = {
  activeGroup: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  groups: PropTypes.shape({}).isRequired,
  setActiveGroup: PropTypes.func.isRequired,
};

const GroupsNavStyled = withStyles(styles)(GroupsNavBare);

export default connect(({ groups, ui }) => ({ activeGroup: ui.activeGroup, groups }), {
  setActiveGroup: uiActions.setActiveGroup,
})(GroupsNavStyled);
